export const getNationalIdFieldType = (mask) => {
  if (!mask) return
  const hasLettersRegex = new RegExp('[a-zA-Z]')
  if (hasLettersRegex.test(mask)) {
    return 'text'
  }
  return 'tel'
}
